import type { CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { CheckoutStep } from "@/constants/CheckoutStep";
import { isDeliveryOptionComplete } from "./delivery";
import { isPaymentComplete, type PaymentSelection } from "./payment";

export { CheckoutStep };

interface ComputeStepInput extends PaymentSelection {
  cart: CartOutputDto | null | undefined;
  isGuest: boolean;
}

export function computeFirstIncompleteStep({ cart, isGuest, ...selection }: ComputeStepInput): CheckoutStep {
  if (!cart) return CheckoutStep.CONTACT_INFO;

  if (isGuest && !cart.customer.email) {
    return CheckoutStep.CONTACT_INFO;
  }

  if (!cart.shippingInfo.shippingAddress) {
    return CheckoutStep.SHIPPING_ADDRESS;
  }

  if (!isDeliveryOptionComplete(cart)) {
    return CheckoutStep.DELIVERY_OPTION;
  }

  if (!isPaymentComplete(cart, selection)) {
    return CheckoutStep.PAYMENT;
  }

  return CheckoutStep.REVIEW;
}

export function getStepName(step: CheckoutStep): string {
  switch (step) {
    case CheckoutStep.CONTACT_INFO:
      return "Contact Info";
    case CheckoutStep.SHIPPING_ADDRESS:
      return "Shipping Address";
    case CheckoutStep.DELIVERY_OPTION:
      return "Delivery Option";
    case CheckoutStep.PAYMENT:
      return "Payment";
    case CheckoutStep.REVIEW:
      return "Review";
  }
}

export function getStepIndividualEventName(step: CheckoutStep): string {
  switch (step) {
    case CheckoutStep.CONTACT_INFO:
      return "Contact Info Added";
    case CheckoutStep.SHIPPING_ADDRESS:
      return "Shipping Address Added";
    case CheckoutStep.DELIVERY_OPTION:
      return "Delivery Info Added";
    case CheckoutStep.PAYMENT:
      return "Payment Info Added";
    default:
      return "";
  }
}
